import { Row, Col, Form, Modal, Button, Table } from "react-bootstrap"
import Icons from "./Icons";

const createTableRowContent = (header, defVal = null) => Object.fromEntries(header.map(col => [col.target, defVal]));
export const createDefaultTable = (header, count, defVal = null) => [...Array(count).keys()].map(() => createTableRowContent(header, defVal));

const BatchTableTextCell = ({ col, rowIdx, dataState, errorState }) => {
  const [data, setData] = dataState;
  const [error, setError] = errorState;
  const handleCellChange = (rowIdx, col, value) => {
    const target = col.target;
    setData(prev => prev.map((row, idx) => rowIdx === idx ? { ...row, [target]: value } : row));
    if (col.validate) {
      setError(prev => prev.map((row, idx) => rowIdx === idx ? { ...row, [target]: col.validate(value) } : row));
    }
  };
  return <div className="d-flex align-items-center">
    <Form.Control
      text="text"
      value={data[rowIdx][col.target] ?? ""}
      onChange={(e) => { handleCellChange(rowIdx, col, e.target.value) }}
      isInvalid={!!error[rowIdx][col.target]}
    />
    <Form.Control.Feedback type="invalid">{error[rowIdx][col.target] ?? ""}</Form.Control.Feedback>
  </div>
}

const BatchTableBoolCell = ({ col, rowIdx, dataState }) => {
  const [data, setData] = dataState;
  const target = col.target
  const modifyCellData = (indicate) => {
    const cellData = data[rowIdx][target];
    const value = cellData === indicate ? null : indicate;
    setData(prev => prev.map((row, idx) => rowIdx === idx ? { ...row, [target]: value } : row));
  };
  return <div className="d-flex align-items-center">
    <Form.Check label={Icons.ok} type="radio" name={`${col.target}-${rowIdx}`} checked={data[rowIdx][target] === true} onClick={() => { modifyCellData(true) }} inline />
    <Form.Check label={Icons.wrong} type="radio" name={`${col.target}-${rowIdx}`} checked={data[rowIdx][target] === false} onClick={() => { modifyCellData(false) }} inline />
  </div>
}

export const BatchTable = ({ header, dataState, errorState }) => {
  const [data,] = dataState;
  return (
    <Table striped>
      <thead>
        <tr>
          <th></th>
          {header.map(col => <th key={col.title}>{col.title}</th>)}
        </tr>
      </thead>
      <tbody>
        {data.map((row, rowIdx) => (
          <tr key={rowIdx}>
            <td>{rowIdx + 1}</td>
            {header.map((col) => {
              return (
                <td key={`${col.target}-${rowIdx}`} >
                  {col.type === "bool" ?
                    <BatchTableBoolCell col={col} rowIdx={rowIdx} dataState={dataState} /> :
                    <BatchTableTextCell col={col} rowIdx={rowIdx} dataState={dataState} errorState={errorState} />
                  }
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    </Table >
  );
};

export const BatchEditActions = ({ showState, title, actionList, skipEntries }) => {
  const [show, setShow] = showState;
  return < Modal show={show} onHide={() => { setShow(false); window.location.reload(false); }} animation="false" size="lg" >
    <Modal.Header closeButton>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {actionList.filter((action) => action.idList[0].length > 0).map((action, rowIdx) => {
        return <div key={`${action.description}-${rowIdx}`}>
          <Row key={`${action.description}-${rowIdx}`}>
            <Col style={action.headStyle}>{action.description}</Col>
            <Col >{action.idList[0].join(", ")}</Col>
          </Row>
          <hr />
        </div>
      })}
      <Row>
        <Col style={{ color: "gray" }}>Skipped, check entry</Col>
        <Col>{Object.keys(skipEntries).map((id, idx) => {
          return <div key={`${id}-${idx}`}>`${id} (${skipEntries[id]})`</div>
        })
        }</Col>
      </Row>
    </Modal.Body>
  </Modal >
}

export const BatchEditButton = ({ invalid, action, running }) => {
  return <>
    <span style={{ color: "red" }}>{invalid}</span>
    <Button variant="primary" onClick={action} disabled={invalid !== "" && !running}>
      {running ? "Saving..." + Icons.running : "Save"}
    </Button>
  </>
}

export const ResetFormCommon = (form) => {
  for (const key in form) {
    form[key][1](key.endsWith("_date") ? new Date() : null)
  }
}

export const ResetTabContent = (tabState, header, defVal = null) => {
  tabState[1](prev => createDefaultTable(header, prev.length, defVal))
}

export default BatchTable
